import SimulationCanvas from './components/SimulationCanvas';
import ControlPanel from './components/ControlPanel';
import { useSimulation } from './hooks/useSimulation';
import './index.css';

function App() {
  const sim = useSimulation();

  return (
    <div className="app">
      <SimulationCanvas
        world={sim.world}
        bodies={sim.bodies}
        selectedId={sim.selectedId}
        showPredictions={sim.showPredictions}
        onSelect={sim.setSelectedId}
        onAddBody={sim.addBody}
      />
      <ControlPanel
        running={sim.running}
        setRunning={sim.setRunning}
        timeScale={sim.timeScale}
        setTimeScale={sim.setTimeScale}
        showPredictions={sim.showPredictions}
        setShowPredictions={sim.setShowPredictions}
        energy={sim.energy}
        bodyCount={sim.bodies.length}
        saves={sim.saves}
        onLoadScenario={sim.loadScenario}
        onClear={sim.clear}
        onSave={sim.saveCurrent}
        onLoadSave={sim.loadSave}
        onDeleteSave={sim.removeSave}
        selectedId={sim.selectedId}
        onRemoveBody={sim.removeBody}
      />
      <footer className="footer">
        Built with Kimi
      </footer>
    </div>
  );
}

export default App;
